import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  GetTaxSettingsResponse,
  TaxSettings,
  UpsertTaxSettingsResponse,
  getTaxSettings as universalGetTaxSettings,
  upsertTaxSettings as universalUpsertTaxSettings,
} from './billing-tax-v1-tax-settings-tax-settings.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/ecom' };

export function getTaxSettings(
  httpClient: HttpClient
): GetTaxSettingsSignature {
  return () =>
    universalGetTaxSettings(
      // @ts-ignore
      { httpClient }
    );
}

interface GetTaxSettingsSignature {
  /**
   * Retrieves the site's tax settings.
   *
   * If the site's tax settings have never been set, default values are returned.
   */
  (): Promise<
    NonNullablePaths<
      GetTaxSettingsResponse,
      `taxSettings.taxIncludedInItemPrices`,
      3
    >
  >;
}

export function upsertTaxSettings(
  httpClient: HttpClient
): UpsertTaxSettingsSignature {
  return (taxSettings: TaxSettings) =>
    universalUpsertTaxSettings(
      taxSettings,
      // @ts-ignore
      { httpClient }
    );
}

interface UpsertTaxSettingsSignature {
  /**
   * Creates or updates the site's tax settings.
   *
   * If the site's tax settings don't exist yet, this method creates them. Otherwise, it updates the existing settings.
   *
   * Since these settings are shared across all Wix products on the site, changes take effect immediately for all integrated products.
   * @param - Tax settings to upsert.
   */
  (taxSettings: TaxSettings): Promise<
    NonNullablePaths<
      UpsertTaxSettingsResponse,
      `taxSettings.taxIncludedInItemPrices`,
      3
    >
  >;
}

export {
  AccountInfo,
  ActionEvent,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  GetTaxSettingsRequest,
  GetTaxSettingsResponse,
  IdentificationData,
  IdentificationDataIdOneOf,
  MessageEnvelope,
  RestoreInfo,
  TaxSettings,
  UpsertTaxSettingsRequest,
  UpsertTaxSettingsResponse,
  WebhookIdentityType,
} from './billing-tax-v1-tax-settings-tax-settings.universal.js';
